import { render, staticRenderFns } from "./AdminBillingCategories.vue?vue&type=template&id=06cc5a9e"
import script from "./AdminBillingCategories.vue?vue&type=script&lang=js"
export * from "./AdminBillingCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports